import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { Collapse } from "reactstrap"
import { Link } from "react-router-dom"
import "../../assets/css/Layout/Header.css"
import Configs from "../../config"
import { FaArrowTrendUp } from "react-icons/fa6"
import {
  FaHome,
  FaUsers,
  FaRupeeSign,
  FaBullhorn,
  FaTree,
  FaRoute,
  FaPhone,
  FaTasks,
  FaWhatsapp,
} from "react-icons/fa"
import { MdPhone, MdSettings } from "react-icons/md"
import { usePermissionData } from "AppContext"

const Navbar = props => {
  const { checkAccess } = usePermissionData()

  const [dashboard, setdashboard] = useState(false)
  const [setting, setSetting] = useState(false)
  const [expense, setExpense] = useState(false)

  useEffect(() => {
    var matchingMenuItem = null
    var ul = document.getElementById("navigation")
    var items = ul.getElementsByTagName("a")
    removeActivation(items)
    for (var i = 0; i < items.length; ++i) {
      if (window.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  })

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement
      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        if (parent.classList.contains("active")) {
          parent.classList.remove("active")
        }
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    if (parent) {
      parent.classList.add("active") // li
      const parent2 = parent.parentElement
      parent2.classList.add("active") // li
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add("active") // li
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add("active") // li
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("active") // li
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add("active") // li
            }
          }
        }
      }
    }
    return false
  }

  return (
    <React.Fragment>
      <div className="topnav ps-1 pe-0" style={{ zIndex: "1001" }}>
        <div className="container-fluid px-0">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav d-flex justify-content-between w-100">
                <div className="d-flex gap-2">
                  {/* dashboard */}
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}dashboard`}
                    >
                      <FaHome size={20} className="me-2 mb-1" />
                      {"Dashboard"} {props.menuOpen}
                    </Link>
                  </li>
                  {/* Staff */}
                  {checkAccess(1, "view") && (
                    <li className="nav-item dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to={`${Configs.appurl}staff`}
                      >
                        <FaUsers size={20} className="me-2 mb-1" />
                        {"Staff"} {props.menuOpen}
                      </Link>
                    </li>
                  )}

                  {/* Lead */}
                  {checkAccess(2, "view") && (
                    <li className="nav-item dropdown">
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to={`${Configs.appurl}leads`}
                      >
                        <FaArrowTrendUp size={20} className="me-2 mb-1" />
                        {"Lead"} {props.menuOpen}
                      </Link>
                    </li>
                  )}

                  {checkAccess(4, "view") && (
                    <li className="nav-item dropdown">
                      <Link
                        to={`${Configs.appurl}cold-calling`}
                        className="nav-link dropdown-toggle arrow-none"
                      >
                        {" "}
                        <MdPhone size={20} className="me-2 mb-1" />
                        Cold Calling
                      </Link>
                    </li>
                  )}

                  {/* Marketing */}
                  {/* <li className="nav-item dropdown">
                    <button className="btn nav-link dropdown-toggle arrow-none">
                      <FaBullhorn size={20} className="me-2 mb-1" />
                      {"Marketing"} {props.menuOpen}
                    </button>
                    <div className="dropdown-menu" id="sales-dropdown">
                      <Link
                        to={`${Configs.appurl}opprtunity`}
                        className="text-dark dropdown-item"
                      >
                        Opprtunity
                      </Link>
                      <Link
                        to={`${Configs.appurl}cold-calling`}
                        className="text-dark dropdown-item"
                      >
                        Cold Calling
                      </Link>
                    </div>
                  </li> */}

                  {/* Payroll */}
                  <li className="nav-item dropdown">
                    {(checkAccess(5, "view") ||
                      checkAccess(6, "view") ||
                      checkAccess(12, "view") ||
                      checkAccess(13, "view") ||
                      checkAccess(14, "view")) && (
                      <>
                        <button className="btn nav-link dropdown-toggle arrow-none">
                          <FaRupeeSign size={20} className="me-2 mb-1" />
                          {"Payroll"} {props.menuOpen}
                        </button>
                        <div className="dropdown-menu" id="sales-dropdown">
                          {checkAccess(12, "view") && (
                            <Link
                              to={`${Configs.appurl}emp-expenses`}
                              className="text-dark dropdown-item"
                            >
                              Employee Expenses
                            </Link>
                          )}
                          {checkAccess(13, "view") && (
                            <Link
                              to={`${Configs.appurl}emp-advance`}
                              className="text-dark dropdown-item"
                            >
                              Employee Advance
                            </Link>
                          )}
                          {checkAccess(14, "view") && (
                            <Link
                              to={`${Configs.appurl}punches`}
                              className="text-dark dropdown-item"
                            >
                              Punch Details
                            </Link>
                          )}

                          {checkAccess(5, "view") && (
                            <Link
                              to={`${Configs.appurl}salary-sheet`}
                              className="text-dark dropdown-item"
                            >
                              Salary Process
                            </Link>
                          )}
                          {checkAccess(6, "view") && (
                            <Link
                              to={`${Configs.appurl}salary-slip`}
                              className="text-dark dropdown-item"
                            >
                              Salary Slip
                            </Link>
                          )}
                        </div>
                      </>
                    )}
                  </li>

                  {/* Location */}
                  <li className="nav-item dropdown">
                    {checkAccess(7, "view") && (
                      <Link
                        className="nav-link dropdown-toggle arrow-none"
                        to={`${Configs.appurl}location-track`}
                      >
                        <FaRoute size={20} className="me-2 mb-1" />
                        {"Location Tracking"} {props.menuOpen}
                      </Link>
                    )}
                  </li>

                  {/* Leaves */}
                  <li className="nav-item dropdown">
                    {(checkAccess(8, "view") || checkAccess(9, "view")) && (
                      <>
                        <button className="btn nav-link dropdown-toggle arrow-none">
                          <FaTree size={20} className="me-2 mb-1" />
                          {"Leave Management"} {props.menuOpen}
                        </button>
                        <div className="dropdown-menu" id="sales-dropdown">
                          {checkAccess(8, "view") && (
                            <Link
                              to={`${Configs.appurl}leaves`}
                              className="text-dark dropdown-item"
                            >
                              Leave
                            </Link>
                          )}
                          {checkAccess(8, "view") && (
                            <Link
                              to={`${Configs.appurl}paidoff`}
                              className="text-dark dropdown-item"
                            >
                              Paid Off
                            </Link>
                          )}
                          {checkAccess(9, "view") && (
                            <Link
                              to={`${Configs.appurl}holiday`}
                              className="text-dark dropdown-item"
                            >
                              Holiday
                            </Link>
                          )}
                        </div>
                      </>
                    )}
                  </li>

                  {/* Task Management */}
                  {/* TODO: gate with backend permission id when available */}
                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}task-management`}
                    >
                      <FaTasks size={20} className="me-2 mb-1" />
                      {"Task Management"} {props.menuOpen}
                    </Link>
                  </li>

                  {/* WhatsApp */}
                  {/* TODO: gate with backend permission id when available */}
                  <li className="nav-item dropdown">
                    <button className="btn nav-link dropdown-toggle arrow-none">
                      <FaWhatsapp size={20} className="me-2 mb-1" />
                      {"WhatsApp"} {props.menuOpen}
                    </button>
                    <div className="dropdown-menu" id="sales-dropdown">
                      <Link
                        to={`${Configs.appurl}wa-templates`}
                        className="text-dark dropdown-item"
                      >
                        Templates
                      </Link>
                      <Link
                        to={`${Configs.appurl}whatsapp-campaign`}
                        className="text-dark dropdown-item"
                      >
                        Campaign
                      </Link>
                      <Link
                        to={`${Configs.appurl}whatsapp-contacts`}
                        className="text-dark dropdown-item"
                      >
                        Contacts
                      </Link>
                      <Link
                        to={`${Configs.appurl}whatsapp-groups`}
                        className="text-dark dropdown-item"
                      >
                        Groups
                      </Link>
                    </div>
                  </li>

                  <li className="nav-item dropdown">
                    {checkAccess(10, "view") && (
                      <>
                        <button className="btn nav-link dropdown-toggle arrow-none">
                          <MdSettings size={20} className="me-2 mb-1" />
                          {"Settings"} {props.menuOpen}
                        </button>
                        <div className="dropdown-menu" id="sales-dropdown">
                          {checkAccess(10, "view") && (
                            <Link
                              to={`${Configs.appurl}roles`}
                              className="text-dark dropdown-item"
                            >
                              Roles
                            </Link>
                          )}
                          {checkAccess(2, "view") && (
                            <Link
                              to={`${Configs.appurl}equipment-category`}
                              className="text-dark dropdown-item"
                            >
                              Equipment Category
                            </Link>
                          )}
                          {checkAccess(2, "view") && (
                            <Link
                              to={`${Configs.appurl}lead-source`}
                              className="text-dark dropdown-item"
                            >
                              Lead Source
                            </Link>
                          )}
                          {checkAccess(10, "view") && (
                            <Link
                              to={`${Configs.appurl}task-status`}
                              className="text-dark dropdown-item"
                            >
                              Task Status
                            </Link>
                          )}
                          {checkAccess(10, "view") && (
                            <Link
                              to={`${Configs.appurl}departments`}
                              className="text-dark dropdown-item"
                            >
                              Departments
                            </Link>
                          )}
                          {checkAccess(11, "view") && (
                            <Link
                              to={`${Configs.appurl}allowances`}
                              className="text-dark dropdown-item"
                            >
                              Allowances
                            </Link>
                          )}
                        </div>
                      </>
                    )}
                  </li>

                  {/* <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}services`}
                    >
                      <MdCleaningServices size={18} className="me-2 mb-1" />
                      {"Services"} {props.menuOpen}
                    </Link>
                  </li> */}

                  {/*<li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}locations`}
                    >
                      <FaMapMarkerAlt size={18} className="me-2 mb-1" />{" "}
                      Locations
                    </Link>
                  </li>

                  <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}payroll-report`}
                    >
                      <FaPoundSign size={18} className="me-2 mb-1" /> Payroll
                      
                    </Link>
                  </li>

                   <li className="nav-item dropdown">
                    <Link
                      className="nav-link dropdown-toggle arrow-none"
                      to={`${Configs.appurl}user-query`}
                    >
                      <MdQuestionAnswer size={18} className="me-2 mb-1" /> Query
                    </Link>
                  </li>

                  <li className="nav-item dropdown">
                    <button className="btn nav-link dropdown-toggle arrow-none">
                      <MdSettings size={18} className="me-2 mb-1" />
                      {"Settings"} {props.menuOpen}
                    </button>
                    <div className="dropdown-menu" id="sales-dropdown">
                      <Link
                        to={`${Configs.appurl}services`}
                        className="text-dark dropdown-item"
                      >
                        <MdCleaningServices size={18} className="me-2 mb-1" />{" "}
                        Services
                      </Link>

                      <Link
                        to={`${Configs.appurl}roles`}
                        className="text-dark dropdown-item"
                      >
                        <MdOutlineSecurity size={18} className="me-2 mb-1" />{" "}
                        Roles
                      </Link>
                    </div>
                  </li> */}
                </div>
              </ul>
              {/* <Dropdown>
                <DropdownToggle nav caret className="text-white">
                  <MdSettings className="me-2" />
                  Settings
                </DropdownToggle>
                <DropdownMenu end>
                  <DropdownItem>
                    <Link
                      to={`${Configs.appurl}locations`}
                      className="text-dark"
                    >
                      <FaLocationPin className="me-2" /> Locations
                    </Link>
                  </DropdownItem>
                  <DropdownItem>
                    <Link to={`${Configs.appurl}roles`} className="text-dark">
                      <FaUser className="me-2" /> Roles
                    </Link>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown> */}
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  )
}

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
}

export default Navbar
